<template>
  <!-- web 头部菜单 -->
  <div class="heard-wrap">
    <div class="web-heard">
      <div class="content">
        <div>
          <img style="height:46px" src="../assets/logo_w.png" />
        </div>
        <div class="menu">
          <!-- 首页 -->

          <div
            class="menu-item"
            @click="goToUrl('/index', 0)"
            :style="{ borderBottomColor: action == '/index' ? '#fff' : '' }"
          >
            首页
          </div>
          <div
            class="menu-item"
            @click="goToUrl('/operation', 0)"
            :style="{
              borderBottomColor: action == '/operation' ? '#8899f2' : ''
            }"
          >
            数字化运营
          </div>
          <!-- 产品介绍 -->

          <!-- <a-popover placement="bottomLeft">
            <template slot="content">
              <div class="product-card">
                <div class="card-main">
                  <p class="title"><b>PRODUCTS</b> ▶</p>
                  <div class="line">
                    <div class="line-item" @click="goToUrl('/mobile', 1)">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/heard/product_icon1.svg"
                      />
                      <p>
                        <span class="line-title">VEDA 移动营销平台</span>
                        <br />
                        <span class="line-content"
                          >对接各大主流媒体流量，为客户打造一站式程序化广告投放平台，助力客户广告营销</span
                        >
                      </p>
                    </div>
                    <div class="line-item" @click="goToUrl('/dmp', 1)">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/heard/product_icon2.svg"
                      />
                      <p>
                        <span class="line-title">VEDA Marketing Dmp</span>
                        <br />
                        <span class="line-content"
                          >厦门偕行星联管理咨询有限
                          公司自主研发，基于媒体数据积累、筛选，精准投放给意向用户</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="line">
                    <div class="line-item" @click="goToUrl('/tool', 1)">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/heard/product_icon3.svg"
                      />
                      <p>
                        <span class="line-title">VEDA 广告营销工具</span>
                        <br />
                        <span class="line-content"
                          >支持多种广告营销工具，如H5落地页制作、创意视频定制等功能，有效提高广告投放效果</span
                        >
                      </p>
                    </div>
                    <div class="line-item" @click="goToUrl('/api', 1)">
                      <img
                        src="http://www.vedamobi.com/assets/website/images/heard/product_icon4.svg"
                      />
                      <p>
                        <span class="line-title">VEDA Marketing API</span>
                        <br />
                        <span class="line-content"
                          >对接多家第三方监控平台，实现跨站式对接，同时支持付费调用第三方数据提升广告投放效果</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card-bottom">
                  <div class="box1"></div>
                  <div class="box2"></div>
                  <div class="box3"></div>
                  <p>
                    偕行营销矩阵
                    <br />
                    <span>MATRIX MARKETING OF VEDA</span>
                  </p>
                </div>
              </div>
            </template>
            <div
              class="menu-item"
              :style="{
                borderBottomColor:
                  action == '/mobile' ||
                  action == '/dmp' ||
                  action == '/tool' ||
                  action == '/api'
                    ? '#8899f2'
                    : ''
              }"
            >
              产品介绍
            </div>
          </a-popover> -->
          <!-- 媒体资源 -->
          <!-- <a-popover placement="bottomLeft">
            <template slot="content">
              <div class="product-card" style="width:308px">
                <p class="title"><b>MEDIA</b> ▶</p>
                <div class="line-item" @click="goToUrl('/weibo', 2)">
                  <img
                    src="http://www.vedamobi.com/assets/website/images/heard/微博.png"
                  />
                  <p>
                    <span class="line-title">微博</span>
                    <br />
                    <span class="line-content"
                      >国内最大的社交媒体，拥有着超过4亿的广大用户群体</span
                    >
                  </p>
                </div>
                <div class="line-item" @click="goToUrl('/zhihu', 2)">
                  <img
                    src="http://www.vedamobi.com/assets/website/images/heard/知乎.png"
                  />
                  <p>
                    <span class="line-title">知乎</span>
                    <br />
                    <span class="line-content"
                      >大型高质量网络问答社区，专业、多元的内容涵盖了生活的方方面面</span
                    >
                  </p>
                </div>
                <div class="line-item" @click="goToUrl('/bilibili', 2)">
                  <img
                    src="http://www.vedamobi.com/assets/website/images/heard/B站.png"
                  />
                  <p>
                    <span class="line-title">哔哩哔哩</span>
                    <br />
                    <span class="line-content"
                      >大型视频互动交流媒体，二次元粉丝聚集地，年轻人的潮流文化娱乐社区</span
                    >
                  </p>
                </div>
              </div>
            </template>
            <div
              class="menu-item"
              :style="{
                borderBottomColor:
                  action == '/weibo' ||
                  action == '/zhihu' ||
                  action === '/bilibili'
                    ? '#8899f2'
                    : ''
              }"
            >
              媒体资源
            </div>
          </a-popover> -->
          <!-- <div
            class="menu-item"
            @click="goToUrl('/cooperationCase', 3)"
            :style="{
              borderBottomColor: action == '/cooperationCase' ? '#8899f2' : ''
            }"
          >
            合作案例
          </div> -->
          <!-- <div
            class="menu-item"
            @click="goToUrl('/article', 4)"
            :style="{
              borderBottomColor: action == '/article' ? '#8899f2' : ''
            }"
          >
            资讯动态
          </div> -->
          <div
            class="menu-item"
            @click="goToUrl('/aboutUs', 5)"
            :style="{
              borderBottomColor: action == '/aboutUs' ? '#8899f2' : ''
            }"
          >
            关于我们
          </div>
        </div>
        <a-button type="primary" @click="goCallUs">立即使用</a-button>
      </div>
    </div>
    <div class="mobile-heard">
      <img src="http://www.vedamobi.com/assets/website/images/favicon.png" />
      <p class="title">偕行星联</p>
      <div @click="showDrawer" class="moblie-right-btn">
        <span class="icons">&#xe608;</span>
      </div>
    </div>
    <a-drawer
      class="mobile-menu-wrap"
      title="偕行星联"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="mobileDrawerVisible"
    >
      <p
        class="mobile-menu"
        @click="goToUrl('/index')"
        :style="{ color: action == '/index' ? '#8899f2' : '' }"
      >
        首页
      </p>
      <p class="mobile-menu" :style="{ color: action == 1 ? '#8899f2' : '' }">
        产品介绍
      </p>
      <p
        class="mobile-menu-item"
        @click="goToUrl('/mobile')"
        :style="{ color: action == '/mobile' ? '#8899f2' : '' }"
      >
        VEDA 移动营销平台
      </p>
      <p
        class="mobile-menu-item"
        @click="goToUrl('/dmp')"
        :style="{ color: action == '/dmp' ? '#8899f2' : '' }"
      >
        VEDA Marketing Dmp
      </p>
      <p
        class="mobile-menu-item"
        @click="goToUrl('/tool')"
        :style="{ color: action == '/tool' ? '#8899f2' : '' }"
      >
        VEDA 广告营销工具
      </p>
      <p
        class="mobile-menu-item"
        @click="goToUrl('/api')"
        :style="{ color: action == '/api' ? '#8899f2' : '' }"
      >
        VEDA Marketing API
      </p>
      <p class="mobile-menu" :style="{ color: action == 2 ? '#8899f2' : '' }">
        媒体资源
      </p>
      <p
        class="mobile-menu-item"
        @click="goToUrl('/weibo')"
        :style="{ color: action == '/weibo' ? '#8899f2' : '' }"
      >
        微博
      </p>
      <p
        class="mobile-menu-item"
        @click="goToUrl('/zhihu')"
        :style="{ color: action == '/zhihu' ? '#8899f2' : '' }"
      >
        知乎
      </p>
      <p
        class="mobile-menu-item"
        @click="goToUrl('/bilibili')"
        :style="{ color: action == '/bilibili' ? '#8899f2' : '' }"
      >
        Bilibili
      </p>
      <p
        class="mobile-menu"
        @click="goToUrl('/cooperationCase')"
        :style="{ color: action == '/cooperationCase' ? '#8899f2' : '' }"
      >
        合作案例
      </p>
      <p
        class="mobile-menu"
        @click="goToUrl('/article')"
        :style="{ color: action == '/article' ? '#8899f2' : '' }"
      >
        资讯动态
      </p>
      <p
        class="mobile-menu"
        @click="goToUrl('/aboutUs')"
        :style="{ color: action == '/aboutUs' ? '#8899f2' : '' }"
      >
        联系我们
      </p>
    </a-drawer>
    <div class="model" v-if="modelVisible">
      <div class="card" :style="{ opacity: modelVisible ? 1 : 0 }">
        <div class="tabs-title">
          <p
            @click="tabsClick(1)"
            :style="{ color: loginAction == 1 ? '#1890ff' : '#333' }"
          >
            注册
          </p>
          <p
            @click="tabsClick(2)"
            :style="{ color: loginAction == 2 ? '#1890ff' : '#333' }"
          >
            登录
          </p>
          <div
            class="bottom-line"
            :style="{
              transform: loginAction == 1 ? `translate(0)` : `translate(100%,0)`
            }"
          ></div>
        </div>

        <!-- 注册表单 -->
        <div v-if="loginAction == 1">
          <a-form class="login-form" :form="registForm" @submit="registSubmit">
            <a-form-item>
              <a-input v-decorator="['company']" placeholder="公司">
                <span class="icon">&#xe8f1;</span>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input v-decorator="['city']" placeholder="城市">
                <span class="icon">&#xe768;</span>
              </a-input>
            </a-form-item>

            <a-form-item>
              <a-input
                v-decorator="[
                  'name',
                  { rules: [{ required: true, message: '请输入姓名!' }] }
                ]"
                placeholder="姓名"
              >
                <span class="icon">&#xe66f;</span>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="[
                  'telephone',
                  { rules: [{ required: true, message: '请输入手机号码!' }] }
                ]"
                placeholder="手机号码"
              >
                <span class="icon">&#xe61a;</span>
              </a-input>
            </a-form-item>

            <a-form-item>
              <a-input
                v-decorator="[
                  'mailbox',
                  { rules: [{ required: true, message: '请输入邮箱!' }] }
                ]"
                placeholder="邮箱"
              >
                <span class="icon">&#xe684;</span>
              </a-input>
            </a-form-item>

            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                class="login-form-button"
                >注册</a-button
              >
            </a-form-item>
          </a-form>
        </div>

        <!-- 登录表单 -->
        <div v-else>
          <a-form class="login-form" :form="loginForm" @submit="loginSubmit">
            <a-form-item>
              <a-input
                v-decorator="[
                  'username',
                  { rules: [{ required: true, message: '请输入账号!' }] }
                ]"
                placeholder="账号名"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color:rgba(0,0,0,.25)"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                type="password"
                v-decorator="[
                  'password',
                  { rules: [{ required: true, message: '请输入密码!' }] }
                ]"
                placeholder="密码"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color:rgba(0,0,0,.25)"
                />
              </a-input>
            </a-form-item>
            <!-- <a-form-item>
              <a-input
                style="width:calc(100% - 130px)"
                v-decorator="[
          'code',
          { rules: [{ required: true, message: '请输入验证码!' }] },
        ]"
                placeholder="验证码"
              >
                <a-icon slot="prefix" type="check-square" style="color:rgba(0,0,0,.25)" />
              </a-input>
              <img class="code-img" />
            </a-form-item>-->

            <a-form-item>
              <a-checkbox
                v-decorator="[
                  'remember',
                  {
                    valuePropName: 'checked',
                    initialValue: true
                  }
                ]"
                >记住账号</a-checkbox
              >
              <!-- <a class="login-form-forgot" href>Forgot password</a> -->
              <a-button
                type="primary"
                html-type="submit"
                class="login-form-button"
                >登录</a-button
              >
            </a-form-item>
          </a-form>
        </div>
        <p
          class="close-btn"
          @click="
            () => {
              modelVisible = false
            }
          "
        >
          &#xe628;
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  props: {},
  data () {
    return {
      action: 0,
      mobileDrawerVisible: false,
      modelVisible: false,
      loginAction: 1,
      loginForm: this.$form.createForm(this, { name: 'login' }),
      registForm: this.$form.createForm(this, { name: 'regist' }),
      loading: false
    }
  },
  mounted () {
    this.action = this.$route.path
  },
  methods: {
    goToUrl (url) {
      this.action = url
      this.$router.push(url)
      this.mobileDrawerVisible = false
    },
    showDrawer () {
      this.mobileDrawerVisible = true
    },
    onClose () {
      this.mobileDrawerVisible = false
    },
    tabsClick (type) {
      this.loginAction = type
      if (type == 2) {
        this.$nextTick(() => {
          const username = localStorage.getItem('user')
          if (username && username != 'undefined') {
            this.loginForm.setFieldsValue({
              username
            })
          }
        })
      }
    },
    goCallUs () {
      this.modelVisible = true

      // window.scrollTo(0, document.documentElement.scrollHeight);
    },
    loginSubmit (e) {
      e.preventDefault()
      this.loginForm.validateFields(async (err, values) => {
        if (!err) {
          if (values.remember) {
            localStorage.setItem('user', values.username)
            axios.create({
              timeout: 5000,
              responseType: 'json'
            })
            const result = await axios.post(
              '/customer/login/ajaxchecklogin',
              qs.stringify(values)
            )
            const res = result.data
            if (res.err == 0) {
              window.location.href = 'http://www.vedamobi.com/vip/'
              this.modelVisible = false
            } else {
              this.$message.error(`${res.errmsg}`)
            }
          }
        }
      })
    },
    registSubmit (e) {
      if (this.loading) return
      this.loading = true
      e.preventDefault()
      this.registForm.validateFields((err, values) => {
        if (!err) {
          this.$jsonp(
            `https://h5.vedamobi.com/index.php/api/api/register?${qs.stringify(
              values
            )}`,
            {},
            (error, data) => {
              if (data.code == 200) {
                this.$message.info('提交成功！')
                this.modelVisible = false
              } else {
                this.$message.error(`${error},${data.msg}`)
              }
              this.loading = false
            }
          )
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.heard-wrap {
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  .web-heard {
    display: block;
    width: 100%;
    background-color: #252c34;
    height: 60px;

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      max-width: 1600px;
      margin: 0 auto;
      .menu {
        position: relative;
        flex: 1;
        max-width: 720px;
        display: flex;
        justify-content: center;
        align-items: center;
        .menu-item {
          cursor: pointer;
          flex: 1;
          height: 60px;
          color: rgb(224, 224, 224);
          line-height: 60px;
          text-align: center;
          background-color: #252c34;
          border-bottom: 3px solid transparent;
          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
}
.product-card {
  width: 684px;
  .card-main {
    width: 100%;
  }
  .title {
    padding: 20px 0 0 20px;
    font-size: 14px;
  }
  .line {
    display: flex;
    align-items: center;
  }
  .line-item {
    cursor: pointer;
    flex: 1;
    display: flex;
    align-items: center;
    padding: 10px;
    img {
      width: 60px;
      height: 60px;
    }
    p {
      margin-left: 10px;
      flex: 1;
      .line-title {
        font-weight: 600;
      }
      .line-content {
        font-size: 12px;
      }
    }
    &:hover {
      background-color: #f9faff;
    }
  }
  .card-bottom {
    position: relative;
    width: 100%;
    height: 160px;
    overflow: hidden;
    background-color: #003fcf;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    .box1 {
      position: absolute;
      background-color: #001443;
      right: -340px;
      top: 0;
      width: 500px;
      height: 500px;
      animation: box1Ani 1s forwards;
    }
    .box2 {
      background-image: linear-gradient(to left, #fff, #232746);
      position: absolute;
      left: -200px;
      top: -200px;
      width: 400px;
      height: 400px;
      opacity: 0.6;
      animation: box2Ani 1s forwards;
    }
    .box3 {
      background-image: linear-gradient(to bottom right, #fff, transparent);
      position: absolute;
      left: -350px;
      bottom: -500px;
      width: 400px;
      height: 600px;
      opacity: 0.8;
      transform: rotate(-40deg);
      animation: box3Ani 1s forwards;
      z-index: 3;
    }
    p {
      margin: 50px 0 0 0;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 34px;
      line-height: 28px;
      span {
        font-size: 15px;
      }
    }
  }
}
.mobile-heard {
  width: 100%;
  height: 60px;
  background-color: #fff;
  display: none;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  .title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
  .moblie-right-btn {
    padding: 5px 14px;
    border-radius: 3px;
    border: 1px solid #eaeaea;
    background-color: #f7f7f7;
    cursor: pointer;
    .icons {
      font-family: 'iconfont';
      color: #8899f2;
      font-size: 20px;
    }
  }
}
.mobile-menu {
  margin: 0;
  padding: 10px;
  width: 100%;
  border-bottom: 1px solid #eee;
}
.mobile-menu-item {
  padding: 10px 24px;
  margin: 0;
  width: 100%;
  border-bottom: 1px solid #eee;
}
.code-img {
  width: 120px;
  height: 50px;
  background-color: #eee;
  margin-left: 10px;
}
@keyframes box1Ani {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(50deg);
  }
}
@keyframes box2Ani {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-50deg);
  }
}
@keyframes box3Ani {
  from {
    transform: rotate(-40deg) translate(0, 0);
  }
  to {
    transform: rotate(-40deg) translate(240px, 0px);
  }
}

@media (max-width: 750px) {
  .heard-wrap .web-heard {
    display: none;
  }
  .heard-wrap .mobile-heard {
    display: flex;
  }
}
.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  .card {
    position: relative;
    transition: opacity 0.4s linear;
    opacity: 0;
    width: 480px;
    margin: 200px auto 0;
    border-radius: 2px;
    background-color: #fff;
    padding: 40px 30px;
    box-sizing: border-box;
    .tabs-title {
      position: relative;
      width: 100%;
      height: 60px;
      border-bottom: 1px solid #eee;
      p {
        width: 50%;
        display: inline-block;
        // border-bottom: 4px #0f8cf0 solid;
        line-height: 56px;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
      .bottom-line {
        width: 50%;
        height: 4px;
        background-color: #1890ff;
        position: absolute;
        left: 0;
        bottom: 0;
        transition: all 0.2s;
      }
    }
    .close-btn {
      position: absolute;
      right: 10px;
      top: 10px;
      font-family: iconfont;
      transform: rotate(90deg);
      font-size: 22px;
      cursor: pointer;
      &:hover {
        color: #1890ff;
      }
    }
  }
}

.login-form {
  margin-top: 20px;
  .login-form-forgot {
    float: right;
  }
  .login-form-button {
    width: 100%;
  }
}
</style>
<style lang="scss">
.ant-popover .ant-popover-inner-content {
  padding: 0;
}
.ant-popover
  .ant-popover-placement-bottomLeft
  > .ant-popover-content
  > .ant-popover-arrow {
  left: 40px;
}
.ant-popover .ant-drawer-body {
  padding: 0;
}
</style>
